

<section class="content">
    <div class="container-fluid">
      <div class="row">
        <!-- left column -->
        <div class="col-md-8">

    

            <div class="card card-primary card-outline card-outline-tabs">
                <div class="card-header p-0 border-bottom-0">
                  <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link active" id="custom-tabs-four-home-tab" data-toggle="pill" href="#custom-tabs-four-home" role="tab" aria-controls="custom-tabs-four-home" aria-selected="true">Nuevos pedidos</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" id="custom-tabs-four-profile-tab" data-toggle="pill" href="#custom-tabs-four-profile" role="tab" aria-controls="custom-tabs-four-profile" aria-selected="false">Pedidos Finalizados</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" id="custom-tabs-four-messages-tab" data-toggle="pill" href="#custom-tabs-four-messages" role="tab" aria-controls="custom-tabs-four-messages" aria-selected="false">Pedidos Anulados</a>
                    </li>
                   
                  </ul>
                </div>
                <div class="card-body">
                  <div class="tab-content" id="custom-tabs-four-tabContent">
                    <div class="tab-pane fade show active" id="custom-tabs-four-home" role="tabpanel" aria-labelledby="custom-tabs-four-home-tab">
                        <div class="col-lg-6 col-12">
                            <!-- small box -->
                            <div class="small-box bg-warning" *ngFor="let dato of previapedidosdto; let i=index">
                              <div class="inner">
                                <h3>{{dato.idPedido}}</h3>
                                
                                <table>
                                    <thead>
                                      <tr>
                                        
                                        <th></th>
                                        <th></th>
                                        
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>Fecha</td>
                                        <td>{{dato.fecha }}</td>
                                      </tr>
                                      <tr>
                                        <td>Hora</td>
                                        <td>{{dato.hora }}</td>
                                      </tr>
                                      <tr>
                                        <td>Cliente:</td>
                                        <td>{{dato.cliente}}</td>
                                      </tr>
                                      <tr>
                                        <td>Total artículos:</td>
                                        <td>{{dato.totalArticulos}}</td>
                                      </tr>
                                      <tr>
                                        <td>Estado:</td>
                                        <td>{{dato.estado}}</td>
                                      </tr>
                                    </tbody>
                                </table>



                              </div>
                              <div class="icon">
                                <i class="ion ion-person-add"></i>
                              </div>
                              <a  class="small-box-footer" (click)="OnSelectPedido(dato.idPedido)">Abrir <i class="fas fa-arrow-circle-right"></i></a>
                            </div>














                          </div>
                    </div>
                    <div class="tab-pane fade" id="custom-tabs-four-profile" role="tabpanel" aria-labelledby="custom-tabs-four-profile-tab">
                     
                    </div>
                    <div class="tab-pane fade" id="custom-tabs-four-messages" role="tabpanel" aria-labelledby="custom-tabs-four-messages-tab">
                      
                    </div>
                    
                  </div>
                </div>
            </div>









</div>
</div>
</div>
</section>


